import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./Header";
import HeroSection from "./HeroSection";
import Testimonials from "./Testimonials";
import Footer from "./Footer";
import AboutUs from "./AboutUs"; // Import the AboutUs component
import Home from "./Home"; // Create a Home component to include HeroSection and Testimonials
import Features from "./Features";
import AnimatedSection from "./AnimatedSection";
import AISkinAnalyzer from "./AISkinAnalyzer";
import Co2LaserPage from "./Co2LaserPage";
import ContactUs from "./ContactUs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import IPLRevivePage from "./IPLRevivePage";
import ThermilifPage from "./ThermilifPage";
import ThermiQRFPage from "./ThermiQRFPage";
import HairRemovalPage from "./HairRemovalPage";
import CicalfatePage from "./CicalfatePage";
import Pictron11Page from "./Pictron11Page";
import ScrollToTop from "./ScrollToTop";

function App() {

  return (
    
    <Router>
 <ScrollToTop/>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/about-us"
            element={
              <AnimatedSection>
                <AboutUs />
              </AnimatedSection>
            }
          />
          <Route
            path="/contact-us"
            element={
              <AnimatedSection>
                <ContactUs />
              </AnimatedSection>
            }
          />

          <Route
            path="/features"
            element={
             
                <Features />
          
            }
          />
           <Route
            path="/HAIRREMOVAL"
            element={
             
                <HairRemovalPage />
          
            }
          />
          <Route
            path="/aiskin"
            element={
             
                <AISkinAnalyzer />
          
            }
          />
             
          <Route
            path="/co2"
            element={
             
                <Co2LaserPage />
          
            }
          />
          <Route
            path="/revive"
            element={
             
                <IPLRevivePage />
          
            }
          />
              <Route
            path="/thermilif"
            element={
             
                <ThermilifPage />
          
            }
          />
               <Route
            path="/rf"
            element={
             
                <ThermiQRFPage />
          
            }
          />
            <Route
            path="/pictron11"
            element={
             
                <Pictron11Page />
          
            }
          />
           <Route
            path="/cicalfate"
            element={
             
                <CicalfatePage />
          
            }
          />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
